import { useUnit } from "effector-react";
import { useEffect } from "react";
import {
  $callsStore,
  fetchCallsRequested,
  loadMoreCallsRequested,
  updateCallBookmark,
  fetchAllCallsCountRequested,
  fetchForYouCallsCountRequested,
  fetchCallGeneralDataRequested,
} from "../store";
import { CallResponse, CallFilters } from "../model/types";

export const useCallsViewModel = () => {
  const [
    callsState,
    fetchCalls,
    loadMoreCalls,
    updateBookmark,
    fetchAllCallsCount,
    fetchForYouCallsCount,
    fetchCallGeneralData,
  ] = useUnit([
    $callsStore,
    fetchCallsRequested,
    loadMoreCallsRequested,
    updateCallBookmark,
    fetchAllCallsCountRequested,
    fetchForYouCallsCountRequested,
    fetchCallGeneralDataRequested,
  ]);

  const fetchCallsWithFilters = (filters?: CallFilters) => {
    fetchCalls(filters);
  };

  useEffect(() => {
    fetchCalls(undefined);
    // Fetch both counts on initialization too costly make a general call instead once to get tab counts
    // fetchAllCallsCount();
    // fetchForYouCallsCount();
    getCallGeneralData();
  }, [fetchCalls, fetchCallGeneralData]);

  const getFilteredCalls = (
    filter: "all" | "for-you" | "my-calls",
  ): CallResponse[] => {
    switch (filter) {
      case "all":
        return callsState.calls;
      case "for-you":
        // For "for-you", the API already filters with type=Eligible, so return all calls
        return callsState.calls;
      case "my-calls":
        return callsState.calls.filter((call) => call.is_call_bookmarked);
      default:
        return callsState.calls;
    }
  };

  const getAllCallsCount = (): number => {
    // console.log("All Calls Count from ViewModel:", callsState.allCallsCount);
    return callsState.allCallsCount;
  };

  const getForYouCallsCount = (): number => {
    // console.log(
      // "For You Calls Count from ViewModel:",
      // callsState.forYouCallsCount,
    // );
    return callsState.forYouCallsCount;
  };

  const loadMoreCallsWithFilters = (filters?: CallFilters) => {
    loadMoreCalls(filters);
  };

  const hasMoreCalls = (): boolean => {
    const totalCalls = callsState.pagination.total;
    const loadedCalls = callsState.calls.length;

    return loadedCalls < totalCalls;
  };

  const getCallGeneralData = async () => {
    await fetchCallGeneralData();
    const response = callsState.callGeneralData;
    if (response) {
      // console.log("Call General Data:", response);
    }
    return response;
  };

  return {
    calls: callsState.calls,
    loading: callsState.loading,
    loadMore: callsState.loadMore,
    error: callsState.error,
    getFilteredCalls,
    getAllCallsCount,
    getForYouCallsCount,
    refetch: fetchCalls,
    fetchCallsWithFilters,
    loadMoreCallsWithFilters,
    hasMoreCalls,
    pagination: callsState.pagination,
    updateBookmark,
    generalCounts: callsState.callGeneralData,
  };
};
